// @flow

import * as React from 'react';
import classnames from 'classnames';
import styles from './styles.scss';
import type { ValidationErrorType } from '../../utils/validation';

type Props = {
  errors: Array<ValidationErrorType>,
  field: string,
  children: React.Node,
};

const ValidatedField = (props: Props) => {
  const errors = props.errors.filter(error => error.field === props.field);

  return (
    // $FlowFixMe
    <div className={classnames(styles.wrapper, { [styles.error]: errors.length > 0 })}>{props.children}</div>
  );
};

export default ValidatedField;



// WEBPACK FOOTER //
// ./src/components/ValidatedField/index.js